import { Church, Hospital, Users, Building2 } from "lucide-react";

const PARTNERS = [
  { icon: Church, t: "Local Churches & Faith Communities", b: "Connecting families with culturally rooted, faith-aware care." },
  { icon: Building2, t: "Senior Living Communities", b: "Supplementing community care with in-home one-on-one support." },
  { icon: Hospital, t: "Hospital Discharge Planners", b: "Smooth, compassionate transitions from hospital back home." },
  { icon: Users, t: "Madison Community Organizations", b: "Trusted neighbors in the network families already rely on." },
];

export default function Community() {
  return (
    <section
      data-testid="community-section"
      className="py-24 md:py-32 bg-[#FFFFFF] relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="gold-divider mb-5">Community & Trust</span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-[#005165] leading-[1.08]">
              A dependable <em className="not-italic text-[#AC9667]">local resource</em> for Madison families.
            </h2>
            <p className="mt-6 text-[17px] text-[#4B5563] leading-relaxed">
              We're proud to partner with churches, senior communities, discharge planners, and
              community organizations across Madison — building a quiet, dependable web of
              support around every family we serve.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {PARTNERS.map((p, i) => (
              <div
                key={p.t}
                data-testid={`community-card-${i}`}
                className="p-7 rounded-2xl bg-white border border-[#E5DDC9]/70 shadow-[0_10px_30px_-20px_rgba(15,23,42,0.18)] hover:shadow-[0_20px_40px_-20px_rgba(217,119,6,0.25)] transition-shadow duration-500"
              >
                <div className="w-12 h-12 rounded-xl bg-[#FFFFFF] border border-[#E5DDC9] flex items-center justify-center mb-4">
                  <p.icon className="w-5 h-5 text-[#AC9667]" strokeWidth={1.6} />
                </div>
                <h3 className="font-serif text-xl text-[#005165] mb-2 leading-tight">{p.t}</h3>
                <p className="text-[14px] text-[#4B5563] leading-relaxed">{p.b}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
